import React from 'react';
import useInput from '../../../Custom Hooks/useInput/useIput';
import {TextField} from '../../../ui-library';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const TextFieldVI = ({helperTextValue = '', initValue = '', getValue = (c) => {}, inputType = 0, inputLabel, onEnterFunc = () => {}, onBlurFunc = () => {}, rows = 0, globalError = '', clearValue = false, disabled = false, inputcolor = 'regular', getError = (c) => {}}) => {
    const {validateInput, value, error, onBlur, onEnter} = useInput(getValue, inputType, onBlurFunc, globalError, initValue, clearValue, onEnterFunc, getError);


    return (
        <TextField
            fullWidth
            onChange={(e) => validateInput(e.target.value) }
            label={inputLabel}
            value={value}
            disabled={disabled}
            helperText={helperTextValue || error || ''}
            inputerror = {error}
            onKeyPress={(e) => onEnterFunc && onEnter(e)}
            inputcolor = {inputcolor}
            onBlur={onBlur}
            multiline={rows > 0}
            rows={rows}
        />

    );
};

export default TextFieldVI;
